module.exports = "../../app/cells/components/campaigns/interventions/square_banner_cell.rb";